import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../Button";
import styles from "./EmptyProfileScreen.module.scss";
import plusIcon from "../../assets/icons/plus.svg";

interface EmptyProfileScreenProps {
  isSelectionMode?: boolean;
  onCreateProfile?: () => void;
}

export const EmptyProfileScreen: React.FC<EmptyProfileScreenProps> = ({
  isSelectionMode = false,
  onCreateProfile,
}) => {
  const navigate = useNavigate();

  const handleCreateProfile = () => {
    if (onCreateProfile) {
      onCreateProfile();
    } else {
      navigate("/profile/edit-profile", {
        state: { title: "Создать профиль" },
      });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <svg
          width="128"
          height="128"
          viewBox="0 0 128 128"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="64" cy="64" r="64" fill="#F5F5F5" />
          <circle cx="64" cy="48" r="20" fill="#E0E0E0" />
          <path
            d="M30 100C30 83.4315 43.4315 70 60 70H68C84.5685 70 98 83.4315 98 100V110H30V100Z"
            fill="#E0E0E0"
          />
        </svg>
      </div>

      <h2 className={styles.title}>У вас еще нет созданных профилей</h2>

      <p className={styles.description}>
        Создайте профили, чтобы ускорить процесс оформления абонементов в нашем
        клубе!
      </p>

      <Button onClickFunc={handleCreateProfile} newStyles={styles.createButton}>
        <div className={styles.buttonContent}>
          <img src={plusIcon} alt="Добавить" className={styles.plusIcon} />
          <span>Создать профиль</span>
        </div>
      </Button>
    </div>
  );
};

